
<template>
    <div class="p-3">

        <b-form @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-6">
                    <b-form-group id="employee_code-group" label="Employee Code" class="required-field" label-for="employee_code">
                      <bot-searchable-select
                          :errorMsg="errorMsg"
                          @change="selectName(fdata.employee_id)"
                          :disabled="mode !== 'add'"
                          :options="employee_ids"
                          v-model="fdata.employee_id"
                          :display-value="fdata.employee_code"
                          :pf="pf"
                      />
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                        <b-form-input disabled id="name" name="name" :value="selectedName"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group id="representative-group" label="Representative" class="required-field" label-for="representative">
                        <b-form-select :disabled="mode == 'end' || (status == 0 && mode != 'add' && mode!='reopen')" :options="representatives" v-model="fdata.representative" class="" name="representative" v-validate="'required'" :state="validateState('representative')" aria-describedby="representative-feedback" :placeholder="'Select representative'"></b-form-select>
                        <b-form-invalid-feedback id="representative-feedback">{{ veeErrors.first('representative') }}</b-form-invalid-feedback>
                    </b-form-group>

                </div>
                <div class="col-6">
                    <b-form-group id="role-group" label="Role" class="required-field" label-for="role">
                        <b-form-select :disabled="mode == 'end' || (status == 0 && mode != 'add' && mode!='reopen')" :options="roles" v-model="fdata.role" name="role" class="" :placeholder="'Select role'" v-validate="'required'" :state="validateState('role')" aria-describedby="role-feedback"></b-form-select>
                        <b-form-invalid-feedback id="role-feedback">{{veeErrors.first('role') }}</b-form-invalid-feedback>
                    </b-form-group>
                </div>

                <div class="col-6">
                    <b-form-group id="role_assignment_date-group" label="Role Assignment Date [YYYY-MM-DD]" class="required-field" label-for="role_assignment_date">
                        <b-input-group class="mb-3">
                            <b-form-input :disabled="mode == 'end'" id="role_assignment_date" name="role_assignment_date" v-model="fdata.role_assignment_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ required: true, date_format: 'yyyy-MM-dd' }"  aria-describedby="role_assignment_date-feedback" data-vv-as="Role Assignment Date" :state="validateState('role_assignment_date')"></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker :min="latestDate" :disabled="mode == 'end'" id="role_assignment_date" button-only right locale="en-US" v-model="fdata.role_assignment_date" ></b-form-datepicker>
                            </b-input-group-append>
                            <b-form-invalid-feedback id="role_assignment_date-feedback">{{ veeErrors.first('role_assignment_date') }}</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group id="expiry_date-group" label="Expiry Date [YYYY-MM-DD]" label-for="expiry_date">
                        <b-input-group class="mb-3">
                            <b-form-input id="expiry_date" name="expiry_date" v-model="fdata.expiry_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ date_format: 'yyyy-MM-dd', required: mode == 'end' }"  aria-describedby="expiry_date-feedback" data-vv-as="Expiry Date" :state="validateState('expiry_date')"></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker :min="minEndDate" id="expiry_date" button-only right locale="en-US" v-model="fdata.expiry_date" ></b-form-datepicker>
                            </b-input-group-append>
                            <b-form-invalid-feedback id="expiry_date-feedback">{{ veeErrors.first('expiry_date') }}</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group id="remarks-group" label="Remarks" label-for="remarks">
                        <b-textarea id="remarks" name="remarks" v-model="fdata.remarks" aria-describedby="remarks-feedback" data-vv-as="Remarks"></b-textarea>
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group id="attachments-group" label="Attachments" label-for="attachments">
                        <b-form-file @change="handleFileUpload" id="attachments" ref="attachments" accept=".jpg,.gif,.png,.pdf,.doc,.xls,.xlsx,.zip"></b-form-file>
                    </b-form-group>
                </div>
                <div v-if="loading" class="col-12">
                    <div class="d-flex justify-content-center">
                        <img :src="$api_url+'/images/loading.gif'" width="30">
                    </div>
                </div>
                <div v-else class="col-12 d-flex justify-content-center">
                    <b-button v-if="mode == 'reopen'" type="submit"  class="float-right mt-3 px-5">Reopen {{trusteeLabel}} Trustee</b-button>
                    <b-button v-if="mode == 'add'" type="submit"  class="float-right mt-3 px-5">Add {{trusteeLabel}} Trustee</b-button>
                    <b-button v-if="mode == 'edit'" type="submit"  class="float-right mt-3 px-5">Update {{trusteeLabel}} Trustee</b-button>
                    <b-button v-if="mode == 'end'" type="submit"  class="float-right mt-3 px-5">End {{trusteeLabel}} Trustee</b-button>
                </div>
            </div>
        </b-form>

        <div v-if="remarks.length > 0 && mode != 'add'" class="row">
            <div class="col-sm-12 px-0">

                <div class="clearfix row py-2 mb-2">
                    <div class="col-sm-12 px-3 company-form-box-title">Remarks:</div>
                </div>

                <b-list-group>
                    <b-list-group-item v-for="(item , n) in remarks" :key="item.id" class="long-text-bot">
                        <strong>{{n+1}}.</strong> {{item.remarks}}
                    </b-list-group-item>
                </b-list-group>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        //this.permission = this.$acl['Role/details'];
    },
    props: ['employee_id', 'name', 'pf', 'mode', 'data_id', 'status'],
    name: 'add-update-user-modal',
    data(){
        return {
          errorMsg:"",
          employeeIdSearchQuery: "",
            aclroles: [], //faroque
            permission: '',
            roles: [],
            representatives: [],
            fdata:{
              employee_id:'',
              representative:null,
              role:null,
              role_assignment_date:null,
              expiry_date:null,
              remarks:'',
              file : null,
              employee_code: '',
            },
          selectedName:'',
          employee_ids:[],
          employees:[],
            loading: false,
            latestDate: null,
            remarks: [],
            // attachments: [],
        }
    },
    methods:{
        handleFileUpload(file) {
            if(!this.checkFileType($event , 'fileInput' , ['.jpg', '.gif' , '.png' ,'.pdf' , '.doc' , '.xls' , '.xlsx' , '.zip'])) return;
            this.fdata.file = file;
        },
        getACLRoles()
        {
            //faroque
          let currentObj = this;
            if(!this.checkNet()) return false;
            axios.post(this.$api_url + '/brac-user/roles/3')
                    .then(function (response) {
                        this.aclroles = response.data;                       

                    }.bind(this))
                    .catch(function (error) {                        
                        currentObj.serverError(error);
                    }); 

        },
      getEmployees()
      {
          axios.get(this.$api_url + '/bot/user/list',{
            params:{
              pf:this.pf
            }
          }).then(response=>{
            
            this.employees = Object.entries(response.data).map(([employee_id, name]) => {
                return {
                    employee_id: employee_id,
                    name: name
                };
            });
            
            this.employees.forEach(e=>{
              this.employee_ids.push({
                  text: e.name,
                  value: e.employee_id,
              });
            })
          })
      },
      selectName(employee_id){
          this.selectedName=this.employees.find(e => e.employee_id == employee_id).name;
      },
        getRoles(){
            axios.get(this.$api_url + '/bot/role/list',{
                params: {
                    type: 'list',
                    pf: this.pf,
                }
            }).then(response => {
                this.roles = response.data;
            }).catch(error => this.serverError(error));
        },
        getRepresentatives(){
            axios.get(this.$api_url + '/bot/role/representatives',{
                params: {
                    type: 'list',
                    pf: this.pf,
                }
            }).then(response => {
                this.representatives = response.data;
            }).catch(error => this.serverError(error));
        },
        gettrusteeInfo(){
          if(this.mode == 'reopen'){
            axios.get(this.$api_url + '/bot/trustee-info/' + this.data_id ,{params:{pf:this.pf}}).then(response => {
              this.fdata.employee_id = response.data.employee_id;
              this.fdata.name = response.data.name;
              this.fdata.employee_code = response.data.employee_code;
              this.selectedName = response.data.name;
            }).catch(error => this.serverError(error));
            return;
          }
            if(this.mode != 'add' && this.mode != 'reopen'){
                axios.get(this.$api_url + '/bot/trustee-info/' + this.data_id ,{params:{pf:this.pf}}).then(response => {
                    this.fdata.employee_id = response.data.employee_id;
                    this.fdata.name = response.data.name;
                    this.fdata.employee_code = response.data.employee_code;
                    this.selectedName = response.data.name;
                    this.fdata.representative = response.data.representative;
                    this.fdata.role = response.data.role_id;
                    this.fdata.role_assignment_date = response.data.role_start_date;
                    this.fdata.expiry_date = response.data.role_end_date;
                    this.remarks = response.data.remarks;
                }).catch(error => this.serverError(error));
            }
        },

        getLastUserRoleDate(){
            axios.get('/bot/user/role/last', {
                params: {
                    mode: this.mode,
                    employee_id : this.employee_id,
                    id: this.data_id,
                  pf: this.pf
                }
            }).then(response => {
                this.latestDate = new Date(response.data);
            }).catch(error => this.serverError(error));
        },

        resetForm(){
            this.fdata = {
                representative:null,
                role:null,
                role_assignment_date:null,
                expiry_date:null,
                remarks:'',
                file : null
            }
        },

        onSubmit(e){
            e.preventDefault();
            this.$validator.validateAll().then(valid => {
              console.log(this.fdata.employee_id)
                if(this.fdata.employee_id == '' || this.fdata.employee_id == null){
                  this.errorMsg = 'The Employee code field is required';
                  return;
                }
                else{
                  this.errorMsg = '';
                }
                if (valid) {
                    const startDate = new Date(this.fdata.role_assignment_date);
                    startDate.setHours(0, 0, 0, 0);
                    const latestDate = new Date(this.latestDate);
                    latestDate.setHours(0, 0, 0, 0);

                    if(this.mode != 'end'){
                        if (startDate < latestDate) {
                            this.$bvToast.toast('Please enter a valid Start Date.', {
                                title: 'Failed',
                                variant: 'warning',
                                solid: true
                            });
                            return;
                        }
                    }

                    if (this.fdata.expiry_date) {
                        const endDate = new Date(this.fdata.expiry_date);
                        endDate.setHours(0, 0, 0, 0);

                        if (startDate > endDate) {
                            this.$bvToast.toast('Start Date cannot be after End Date.', {
                                title: 'Failed',
                                variant: 'warning',
                                solid: true
                            });
                            return;
                        }
                    }


                    this.loading = true;
                    let formData = new FormData();
                    formData.append('employee_id', this.employee_id);
                    formData.append('name', this.selectedName);
                    formData.append('action', this.mode);

                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                  if (typeof this.fdata.employee_id === 'object' && this.fdata.employee_id !== null && !Array.isArray(this.fdata.employee_id)) {
                    this.fdata.employee_id = this.fdata.employee_id.value
                  }

                  for(const [key, val] of Object.entries(this.fdata)){
                        formData.append(key, val);
                    }
                    if(this.mode != 'add'){
                        formData.append('id', this.data_id)
                    }
                    formData.append('pf', this.pf);
                    
                    axios.post(this.$api_url + '/bot/user/role/save?pf='+this.pf,formData,config).then(response =>{
                        this.$bvToast.toast(response.data.message, {
                            title: response.data.title,
                            variant: response.data.variant,
                            solid: true
                        });
                        this.$emit('hideModal')
                        this.loading = false;
                        // this.resetForm()
                    })
                    .catch(error => {
                        this.serverError(error);
                        this.loading = false;
                    });
                }
            });


        }
    },
    created(){
        // this.getACLRoles();
        this.getRoles();
        this.getRepresentatives();
        this.gettrusteeInfo();
        this.getLastUserRoleDate();
        this.getEmployees();
    },
    computed:{
        minEndDate(){
            const endDate = new Date(this.fdata.role_assignment_date);
            endDate.setHours(0, 0, 0, 0);
            endDate.setDate(endDate.getDate() + 1);
            return endDate
        },
      trusteeLabel() {
          if (this.pf == 1) return 'PF';
          if (this.pf == 0) return 'GF';
          if (this.pf == 2) return 'WF';
          return '';
      }
    }
}
</script>
